import React from 'react'

function NodataFound() {
  return (
    <div className='nodata_Found'>No Data Found</div>
  )
}

export default NodataFound